export default __webpack_public_path__ + "c92dd1a7fdd0f17a72d83a0a61887d42.png";